import s from './styles.module.less';

// TODO: find better place for them
export const NO_MARGIN_BOTTOM = { marginBottom: 0 };
export const NO_MARGIN_TOP = { marginTop: 0 };
// TODO: Add better naming
export const COL_WITH_EXTRA = { span: 19 };
// TODO: Add better naming
export const NARROW_COL = { span: 14 };
export const SEARCHABLE_SELECT_PROPS = {
  showSearch: true,
  labelInValue: true,
  notFoundContent: null,
  defaultActiveFirstOption: false,
  filterOption: false,
  allowClear: true,
};

export const FULL_WIDTH = { width: '100%' };
export const DISABLED_CLASSNAME = s.disabled;

export const SLUG_PATTERN = /^[a-z0-9-]+$/;
export const SLUG_RULE = {
  pattern: SLUG_PATTERN,
  message: 'Wrong slug format. Can contain lowercase latin letters, numbers and dashes',
};

export const TITLE_RULE = { max: 120, message: 'The title should be less than 120 chars' };

export const LOCALES = [
  ['en', 'English'],
  ['fr', 'French'],
];

export const ADDITIONAL_COLOURS = [...Array(10)].map((_, id) => ({ id, value: '' }));

export const DEFAULT_LOCALE = LOCALES[0][0];
export const DEFAULT_LANGUAGE = [{ code: 'en', name: 'English' }];

export const DEFAULT_DELAY = process.env.NODE_ENV === 'test' ? 0 : 100;

export const EMPTY_OBJ = {};
export const EMPTY_ARR = [];

export const WA_WHITE = '#ffffff';
export const WA_DARK_GREY = '#333333';
export const WA_ORANGE = '#FF873C';
export const WA_OCEANIC = '#69D7E1';
export const WA_GREEN = '#A5FA64';
export const WA_PURPLE = '#BD94FF';
export const WA_RED = '#F8485E';
export const WA_YELLOW = '#F6EB14';
export const WA_BLACK = '#000000';
export const WA_TRANSPARANT = '#ffffff00';

export const BRANDED_COLOURS = [WA_ORANGE, WA_OCEANIC, WA_GREEN, WA_PURPLE];
export const OREGON_COLOURS = [WA_RED];
export const TEXT_COLOURS = [WA_WHITE, WA_DARK_GREY];
export const SPIKES_COLOURS = [WA_YELLOW, WA_BLACK];
export const ULTIMATE_DESIGN_BACKGROUND_COLORS = [WA_BLACK, WA_TRANSPARANT];

export const GRADIENTS = {
  'gradient-1': {
    key: 'gradient-1',
    value: 'linear-gradient(268deg, #803004 0%, #CD591E 36%, #FA7D3D 55%, #FAD45C 100%) 0% 0% no-repeat padding-box',
  },
  'gradient-2': {
    key: 'gradient-2',
    value: 'linear-gradient(268deg, #e06eba 0%, #eaa79a 50%, #f0e155 100%) 0% 0% no-repeat padding-box',
  },
  'gradient-3': {
    key: 'gradient-3',
    value: 'linear-gradient(268deg, #0AF7E1 0%, #19E1E1 50%, #8B87F9 100%) 0% 0% no-repeat padding-box',
  },
};

export const PAGE_DELETE_WARNING =
  'This page has child pages. Please reassign child pages to another parent or they will be deleted automatically with this page.';

export const PAGES_DELETE_WARNING =
  'One or more pages might have child pages. Please reassign child pages to another parent or they will be deleted automatically with this page.';

export const ARTICLE_DELETE_WARNING = 'Please consider that some articles might be still linked to published pages';

export const EMAIL_SEND_WARNING = `Are you sure it's ready to send? Have you checked the selected audience and any links`;

export const PAGE_DELETE_LANGUAGE_WARNING = 'This page may have other language versions. They will also be deleted.';

export const ARTICLE_DELETE_LANGUAGE_WARNING =
  'This article may have other language versions. They will also be deleted.';
